import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const PriceTicker = () => {
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await axios.get(`${API}/bitcoin/price`);
        setPrice(response.data.bitcoin);
      } catch (error) {
        console.error('Error fetching price:', error);
      }
    };

    fetchPrice();
    const interval = setInterval(fetchPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!price) return null;

  return (
    <div className="bg-black text-white py-2 overflow-hidden" data-testid="price-ticker">
      <div className="animate-marquee whitespace-nowrap font-mono text-sm tracking-widest uppercase">
        <span className="mx-8">BTC/USD: ${price.usd?.toLocaleString()} ({price.usd_24h_change?.toFixed(2)}%)</span>
        <span className="mx-8">BTC/BRL: R$ {price.brl?.toLocaleString()}</span>
        <span className="mx-8">BTC/USD: ${price.usd?.toLocaleString()} ({price.usd_24h_change?.toFixed(2)}%)</span>
        <span className="mx-8">BTC/BRL: R$ {price.brl?.toLocaleString()}</span>
      </div>
    </div>
  );
};